import PropTypes from 'prop-types'
import TableToolbar from '../../../../../components/stories/organisms/table/components/toolbar'
import ShowInactiveProjectSwitch from '../../show-inactive-projects-switch'

const ProjectMenuTileToolbar = ({
  setSearch = () => {},
  search,
  setShowInactive = () => {},
  showInactive,
  hideToggle = false
}) => {
  return (
    <TableToolbar.Root>
      <TableToolbar.LeftContainer>
        <TableToolbar.Search
          value={search}
          onChangeSearch={setSearch}
          defaultDesktopVariantOpen={!!search}
        />
        {!hideToggle && (
          <ShowInactiveProjectSwitch
            checked={showInactive}
            onCheckedChange={setShowInactive}
          />
        )}
      </TableToolbar.LeftContainer>
      <TableToolbar.RightContainer />
    </TableToolbar.Root>
  )
}

ProjectMenuTileToolbar.propTypes = {
  search: PropTypes.string,
  setSearch: PropTypes.func,
  setShowInactive: PropTypes.func,
  showInactive: PropTypes.bool,
  hideToggle: PropTypes.bool
}

export default ProjectMenuTileToolbar
